import React from 'react';
import Medication from '../cards/general/Medication';
import OtherDetail from '../cards/general/OtherDetail';
import PatientDetail from '../cards/general/PatientDetail';
import Todo from '../cards/general/Todo';
import Appointment from '../cards/general/Appointment';
import Vaccination from '../cards/general/Vaccination';
import History from '../cards/general/History';
import Preventive from '../cards/general/Preventive';
import Visit from '../cards/general/Visit';
import FamilyHistory from '../cards/general/FamilyHistory';
import Reaction from '../cards/general/Reaction';
import Reminder from '../cards/general/Reminder';
import RequestPath from '../cards/general/RequestPath';
import Prescription from '../cards/general/Prescription';
import { connect } from 'react-redux';
import { selectedPatient } from '../../actions';

class Summary extends React.Component {


    componentDidMount() {
        this.props.selectedPatient(this.props.match.params.id);
    }

    componentDidUpdate() {
        this.props.selectedPatient(this.props.match.params.id);
    }
    

    render() {   
        return (
      
            <div className='flex-container'>
                <Visit />
                <Reminder />
                <Reaction />
                <RequestPath />
                <FamilyHistory />
                <Prescription />
                <History />  
                <Appointment /> 
                <Medication />
                <Vaccination />        
                <Todo />
                <Preventive />
                <PatientDetail />
                <OtherDetail />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return { 
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {selectedPatient})(Summary);